import { render, staticRenderFns } from "./ReviewableUpload.vue?vue&type=template&id=4799832e"
import script from "./ReviewableUpload.vue?vue&type=script&lang=js"
export * from "./ReviewableUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports